import React from "react";
import styled from "styled-components";
import { Link } from 'react-router-dom';

const Header = (props) =>{
    return (
        <>
        <Wrap>
            <Link to="/">
            <h1>😆 나만의 단어장 😆</h1>
            </Link>
        </Wrap>
        </>
    )
        
    
};

const Wrap =styled.header`
    width:100%;
    position: fixed;
    height:80px;
    float:left;
    display:flex;
    align-items:center;
    justify-content:center;
    background-color:#fff;
    border-bottom:1px solid #97ACE3;
    z-index:99;
    @media screen and (max-width: 500px){
        height:60px;
        }

    & > a{
        text-align:center;
        font-family:"Gugi";
        cursor:pointer;
    }
    & h1{
        @media screen and (max-width: 500px){
            font-size:24px;
        }
    }
`;
export default Header;